import * as React from 'react'
import styled from "styled-components"
import { ConversationMessageArticle, HelpCenter, HelpCenterArticle, PublicLocale } from '../../../../../types'
import MobilityHelper from '../../../../../helpers/MobilityHelper'
import ArticlesController from '../../../../../controllers/ArticlesController'
import { HelpCenterController } from '../../../../controllers'
import { useHistory } from 'react-router-dom'
import { articleLink } from '../../../../helpers/NavigationHelper'
import HelpCenterHelper from '../../../../../helpers/HelpCenterHelper'

const Container = styled.div`
  width: 100%;
  padding: 15px 20px;
  border-radius: 8px;
  margin-top: 4px;
  box-shadow: 0px 1px 4px 0px rgba(20, 20, 20, 0.15);
  font-size: 14px;
  line-height: 1.4;
  box-sizing: border-box;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  cursor: pointer;

  &:hover {
    background-color: #f5f5f5;
  }
`

const Title = styled.div`
  color: black;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 4px;
`
const Description = styled.div`
  color: #646462;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

interface IProps {
  admin: boolean
  message: ConversationMessageArticle
}

interface IState {
  article: HelpCenterArticle
  helpCenter: HelpCenter
  didInitialLoad: boolean
}

const Article = (props: IProps) => {
  const { admin, message } = props
  const history = useHistory()
  const [state, setState] = React.useState<IState>({
    article: null,
    helpCenter: null,
    didInitialLoad: false,
  })
  const { didInitialLoad, article, helpCenter } = state

  React.useEffect(() => {
    fetchArticle()
  }, [])

  const fetchArticle = async () => {
    try {
      let article = null
      let helpCenter = null

      if (admin) { // Admin back office
        const { article: helpCenterArticle, help_center } = await ArticlesController.getForm(message.help_center_id, { id: message.article_id })
        article = helpCenterArticle
        helpCenter = help_center
      } else { // Messenger mode
        const { article: helpCenterArticle, } = await HelpCenterController.getArticle(message.article_id)
        article = helpCenterArticle
        helpCenter = null
      }

      setState({
        ...state,
        article: article,
        helpCenter: helpCenter,
        didInitialLoad: true,
      })
    } catch (ex) {
      console.error(ex)
      setState({ article: null, helpCenter: null, didInitialLoad: false })
    }
  }

  const onClick = () => {
    if (!article) return

    if (admin) {
      window.open(HelpCenterHelper.getArticleUrl(helpCenter, article, message.locale as PublicLocale), '_blank')
    } else {
      history.push(articleLink(article))
    }
  }

  if (!didInitialLoad) {
    return (
      <Container>
        <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYwIiBoZWlnaHQ9IjYwIiB2aWV3Qm94PSIwIDAgMTYwIDYwIiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIyIiB5PSI2IiB3aWR0aD0iMTU2IiBoZWlnaHQ9IjEyIiByeD0iNCIgZmlsbD0iI0U4RThFOCIvPgo8cmVjdCB4PSIyIiB5PSIyOCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjgiIHJ4PSI0IiBmaWxsPSIjRThFOEU4Ii8+CjxyZWN0IHg9IjIiIHk9IjQ2IiB3aWR0aD0iNjAiIGhlaWdodD0iOCIgcng9IjQiIGZpbGw9IiNFOEU4RTgiLz4KPC9zdmc+Cg==" width="160" height="60"></img>
      </Container>
    )
  }

  const title = MobilityHelper.getTranslation(message.locale, article.translations, 'title')
  const description = MobilityHelper.getTranslation(message.locale, article.translations, 'summary')

  return (
    <Container onClick={onClick} title={title}>
      <Title>{title}</Title>
      <Description>{description}</Description>
    </Container>
  )
}

export default Article